import React from 'react';

import { loadHotelsList, saveHotelsItem } from 'store/slices/hotels/actions';
import { useAppDispatch, useAppSelector } from 'store';
import { SampleList } from 'components/Sample/SampleList';
import { PageTitles } from 'constants/pageTitles';
import { IHotelsItem } from 'store/slices/hotels/interfaces';

interface IProps {
  sortFieldName?: keyof Pick<
    IHotelsItem,
    'sortPriority' | 'sortPriorityMainPage'
  >;
  limit?: number;
  isSortPriority?: boolean | null;
}

export const List: React.FC<IProps> = ({
  sortFieldName = 'sortPriority',
  limit,
  isSortPriority = true,
}) => {
  const dispatch = useAppDispatch();
  const data = useAppSelector(state => state.hotels);

  const tableData = data.list.map(item => ({
    title: item.name,
    id: item.id,
    sortPriority: item[sortFieldName],
    image: item.image,
    address: item.address,
  }));

  const handleRemove = async (id: number): Promise<any> => {
    return dispatch(
      saveHotelsItem({
        id,
        [sortFieldName]: null,
      })
    ).unwrap();
  };

  const handleLoadData = (lang: string) => {
    dispatch(
      loadHotelsList({ lang: lang, limit, sort: sortFieldName, isSortPriority })
    );
  };
  return (
    <SampleList
      data={tableData}
      handleLoadData={handleLoadData}
      handleDelete={handleRemove}
      isLoading={data.isLoading}
      title={PageTitles.hotels}
      limit={limit}
    />
  );
};
